(function ( $ ) {
    $.fn.updateOnClick = function(fn_to_replace, callback) {
        this.each(function() {
            var a = $(this);
            var onclick = a.attr('onclick');
            if(onclick != undefined && onclick.indexOf(fn_to_replace+'(') !== -1) {
                var tr = a.parents('tr');
                var id = tr.attr('data-id');
                a.removeAttr('onclick').click(function(e) {
                    callback(id);
                    return false;
                });
            }

        });
        return this;
    }
}( jQuery ));